import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../components/primitives/SMLButton';
import { wishBoxMessages as messages } from './wishBoxMessages';
import styles from './WishBoxSent.module.scss';

/** The state after a 2xx (design wish-box a4). Done closes the box. */
const WishBoxSentComponent: React.FC<{ onDone: () => void }> = ({ onDone }) => {
  const intl = useIntl();
  return (
    <div className={styles.done}>
      <span className={styles.doneMark} aria-hidden>
        ✓
      </span>
      <h2 id="wish-box-title" className={styles.title}>
        {intl.formatMessage(messages.sentTitle)}
      </h2>
      <p className={styles.text}>{intl.formatMessage(messages.sentBody)}</p>
      <SMLButton variant="primary" onClick={onDone}>
        {intl.formatMessage(messages.done)}
      </SMLButton>
    </div>
  );
};

export const WishBoxSent = TypedMemo(WishBoxSentComponent);
